module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/1b63f5631ecfdf2d32b02f5d6de84ea2.png";